/**
 * Ryan O'Dowd
 * 2023-01-28
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const EnglishNote = () => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <Text style={styles.text}>Feedback Chat is currently available in English only.</Text>
    </View>
  );
};

export default EnglishNote;
